import React from "react";
import { useSelector } from "react-redux";
import aboutImage from "./about.png";

function Header() {
  const { isMobileDevice } = useSelector((state) => state.auth);

  return (
    <div
      className={`relative ${
        isMobileDevice ? "" : "min-h-screen"
      } flex flex-col md:flex-row items-center justify-center bg-cover bg-center p-8 text-center md:text-left`}
      style={{ paddingTop: isMobileDevice ? 80 : 0 }}
    >
      {/* Background Image with Opacity */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-15"
        style={{ backgroundImage: `url(${aboutImage})` }}
      ></div>

      {/* Content */}
      <div className="relative z-5 flex flex-col md:flex-row items-center w-full">
        {/* Mobile Mockup */}
        <div className="w-full md:w-2/5 flex justify-center mb-10 md:mb-0">
          <img
            src="/assets/mobile_mockup.png"
            alt="Clubchat App"
            className="w-72 md:w-80 contrast-125"
          />
        </div>

        {/* Text Content */}
        <div className="w-full md:w-3/5 md:pl-8 flex flex-col space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight">
          Join or Discover College Clubs and Events!
          </h1>
          <p className="text-2xl text-gray-600">
            Your ultimate platform for discovering and engaging with academic
            clubs.
          </p>
          <p className="text-2xl font-semibold">Clubchat is free to use!</p>

          {/* Download Buttons */}
          <div className="flex flex-wrap justify-center md:justify-start gap-4 pt-4">
            <a
              href="https://play.google.com/store/apps/details?id=in.learningx.club_app"
              className="flex items-center bg-white border border-gray-200 rounded-lg px-5 py-2 shadow-sm hover:shadow-md transition-all duration-200"
            >
              <img
                src="/assets/playstor.png"
                alt="Google Play"
                className="w-10 h-10 mr-3"
              />
              <div>
                <p className="text-xs text-gray-600">Download on</p>
                <p className="text-lg font-bold text-gray-900">Google Play</p>
              </div>
            </a>
            <a
              href="https://apps.apple.com/in/app/clubchat-academic-club-more/id6612034727"
              className="flex items-center bg-white border border-gray-200 rounded-lg px-5 py-2 shadow-sm hover:shadow-md transition-all duration-200"
            >
              <img
                src="/assets/appstor.png"
                alt="App Store"
                className="w-10 h-10 mr-3"
              />
              <div>
                <p className="text-xs text-gray-600">Download on</p>
                <p className="text-lg font-bold text-gray-900">App Store</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
